function fetchRecommendations(metadataId, apiClient) {
  const route = apiClient.route`/libraries/${':librarySubdomain'}/bibs/search/recommendations/${metadataId}`;
  return apiClient.get(route);
}

export default {
  fetchRecommendations
};
